
export default (t) => [
  {
    text: t('Branch'),
    value: 'branch',
    sortable: false,
    togglable: true
  },
  {
    text: t('Status'),
    value: 'status',
    sortable: false,
    width: 80,
    togglable: true
  },
  {
    text: t('Opened By'),
    value: 'opened_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Opened At'),
    value: 'opened_at',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Closed By'),
    value: 'closed_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Closed At'),
    value: 'closed_at',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Net Sales'),
    value: 'net_sales',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
